import React, { memo, useCallback, useEffect, useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import { useTranslation } from 'react-i18next';

import { generalHelpers } from '../../helpers';
import { useUser } from '../../hooks/users';
import RegisterPage from '../../modules/User/RegisterPage';

/**
 * Show a pop up every 30 mins for unregistered users
 */
const RegistrationPopup: React.FC = () => {
  const user = useUser();

  const [show, setShow] = useState(false);
  const handleHide = useCallback(() => {
    setShow(false);
  }, []);

  const popup = useCallback(() => {
    setShow(true);
  }, []);

  useEffect(() => {
    if (!user) {
      const handler = setInterval(popup, 1_800_000);
      return () => {
        clearInterval(handler);
      };
    }
    return generalHelpers.noop;
  }, [popup, user]);

  const [t] = useTranslation();

  return (
    <Modal show={show} size="lg" centered onHide={handleHide}>
      <Modal.Header closeButton>
        <Modal.Title>{t('register-to-see-more')}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div style={{ marginTop: '-3rem', marginBottom: '1rem' }}>
          <RegisterPage fullWidth />
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default memo(RegistrationPopup);
